module.exports = __webpack_public_path__ + "static/media/trivialoot.cd2c7d8f.jpg";